import { Empty } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'

export const NotFoundPage = () => {
    return (
        <Empty
            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
            imageStyle={{ height: '250px' }}
            style={{ minHeight: '100vh', }}
            description={
                <span>
                    Not Found Page <Link to={'/'}>Go Home</Link>
                </span>
            }
        >
        </Empty>
    )
}
